<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="transactions"
	[loading]="!transactions"
	[globalFilterFields]="app.keys(transactions)"
	[rowHover]="true"
	[rows]="10"
	[showCurrentPageReport]="true"
	[rowsPerPageOptions]="[10, 25, 50]"
	responsiveLayout="scroll"
	[paginator]="true"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} recordName"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="exportExcel()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'file-excel']" size="lg" class="ms-1 me-2"></fa-icon>
					</div>
				</ng-template>
			</p-button>
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="Summary.TimeStamp">
				<div class="d-flex w-100">
					Date/Time
					<p-sortIcon field="TimerStamp"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="Summary.TimeStamp" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="Summary.Invoice">
				<div class="d-flex w-100">
					Check Number
					<p-sortIcon field="Invoice"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="number" field="Summary.Invoice" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="Summary.Amount">
				<div class="d-flex w-100">
					Amount
					<p-sortIcon field="Amount"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="number" field="Summary.Amount" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="Summary.LastFour">
				<div class="d-flex w-100">
					Card Number / Type
					<p-sortIcon field="LastFour"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter
							field="Summary.CardBrand"
							matchMode="equals"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
							class="ml-auto"
						>
							<ng-template pTemplate="header">
								<div class="px-3 pt-3 pb-0">
									<span class="font-bold">Card Type</span>
								</div>
							</ng-template>
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-multiSelect
									[ngModel]="value"
									[options]="cardTypeList"
									optionValue="value"
									optionLabel="label"
									placeholder="Any"
									(onChange)="filter($event.value)"
								>
									<ng-template let-option pTemplate="item">
										<div class="p-multiselect-representative-option">
											<fa-icon [icon]="['fab', option.meta]" class="me-2" size="lg"></fa-icon>
											<span class="ml-1">{{ option.label }}</span>
										</div>
									</ng-template>
								</p-multiSelect>
							</ng-template>
						</p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="Summary.TranCode">
				<div class="d-flex w-100">
					Transaction Type
					<p-sortIcon field="Summary.TranCode"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter
							field="Summary.TranCode"
							matchMode="in"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
							class="ml-auto"
						>
							<ng-template pTemplate="header">
								<div class="px-3 pt-3 pb-0">
									<span class="font-bold">Tran Type</span>
								</div>
							</ng-template>
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-multiSelect
									[ngModel]="value"
									[options]="tranCodeList"
									optionValue="value"
									optionLabel="label"
									placeholder="Any"
									(onChange)="filter($event.value)"
									optionLabel="name"
								>
									<ng-template let-option pTemplate="item">
										<div class="p-multiselect-representative-option">
											<span class="ml-1">{{ option.label }}</span>
										</div>
									</ng-template>
								</p-multiSelect>
							</ng-template>
						</p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="Summary.Status">
				<div class="d-flex w-100">
					Status
					<p-sortIcon field="Status"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="Summary.Status" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="selectTransaction(rec.Summary.Invoice, rec.Summary.businessDate)">
			<td>{{ app.moment(rec.Summary.TimeStamp).format('L LT') }}</td>
			<td>{{ rec.Summary.Invoice }}</td>
			<td>{{ rec.Summary.Amount | currency }}</td>
			<td>
				<div class="p-grid">
					<div class="p-col-2">
						{{ rec.Summary.LastFour }}
					</div>
					<div class="p-col-8">
						<fa-icon *ngIf="rec.Summary.CardBrand === 'VISA'" [icon]="['fab', 'cc-visa']"></fa-icon>
						<fa-icon *ngIf="rec.Summary.CardBrand === 'AMEX'" [icon]="['fab', 'cc-amex']"></fa-icon>
						<fa-icon *ngIf="rec.Summary.CardBrand === 'DCVR'" [icon]="['fab', 'cc-discover']"></fa-icon>
						<fa-icon *ngIf="rec.Summary.CardBrand === 'M/C'" [icon]="['fab', 'cc-mastercard']"></fa-icon>
					</div>
				</div>
			</td>
			<td>{{ rec.Summary.TranCode }}</td>
			<td>{{ rec.Summary.Status }}</td>
		</tr>
	</ng-template>
</p-table>

<p-sidebar [(visible)]="checkSelected" position="right" appendTo="body" (onHide)="checkSelected = undefined" [showCloseIcon]="false" styleClass="p-sidebar-md">
	<app-check-record-viewer *ngIf="checkSelected" [incomingCheck]="checkSelected"></app-check-record-viewer>
</p-sidebar>
